import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useLplModel } from "../lplModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useLplModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "外贸合同号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["签订起始日期", "签订结束日期"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        }
    ]

    return (
        <YhPageHeader
            title="合同进程列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}